/* XBavly product reviews: horizontal slider on desktop and mobile. Replace xb-reviews-ui.js. */
window.XBReviewsUI = {
  createWidget(ctx) {
    return `
      <section class="xb-reviews" aria-label="${XBReviewsUtils.escape(ctx.text.title)}">
        ${this.createHero(ctx)}
        ${this.createToolbar(ctx)}
        ${this.createReviewList(ctx)}
      </section>
    `;
  },
    mountModal(ctx) {
    document.getElementById("xb-review-modal-portal")?.remove();
    const portal = document.createElement("div");
    portal.id = "xb-review-modal-portal";
    portal.className = "xb-reviews-root " + (ctx.isAr ? "xb-rtl" : "xb-ltr");
    portal.innerHTML = this.createModal(ctx);
    document.body.appendChild(portal);
    return portal.querySelector(".xb-modal");
  },
  createHero(ctx) {
    const rawAverage = Number(ctx.data?.stats?.average);
    const average = Number.isFinite(rawAverage)
      ? Math.min(5, Math.max(0, rawAverage))
      : 0;
    const count = Math.max(0, Math.floor(Number(ctx.data?.stats?.count) || 0));
    const averageLabel = ctx.isAr ? "متوسط التقييم" : "AVERAGE RATING";
    const starsLabel = ctx.isAr
      ? `${average.toFixed(1)} من 5 نجوم`
      : `${average.toFixed(1)} out of 5 stars`;
    return `
      <div class="xb-review-hero">
        <div class="xb-review-score-box">
          <span class="xb-score-kicker">${XBReviewsUtils.escape(averageLabel)}</span>
          <strong class="xb-big-score">${count ? average.toFixed(1) : "—"}</strong>
          <div class="xb-score-details">
            <div class="xb-stars" role="img" aria-label="${XBReviewsUtils.escape(starsLabel)}">
              <span aria-hidden="true">★★★★★</span><span class="xb-stars-fill" aria-hidden="true" style="width:${Math.round(average * 20 * 100) / 100}%">★★★★★</span>
            </div>
            <div class="xb-score-sub">
              ${XBReviewsUtils.escape(ctx.text.basedOn)} ${count} ${XBReviewsUtils.escape(ctx.text.reviews)}
            </div>
          </div>
        </div>
        ${this.createBreakdown(ctx)}
      </div>
    `;
  },
createReminder(ctx) {
  return "";
},
  createBreakdown(ctx) {
    const total = Math.max(0, Math.floor(Number(ctx.data?.stats?.count) || 0));
    const breakdown = Array.isArray(ctx.data?.breakdown) ? ctx.data.breakdown : [];
    const map = {};
    for (const row of breakdown) {
      const rating = Math.floor(Number(row?.rating));
      const count = Math.max(0, Math.floor(Number(row?.count) || 0));
      if (rating >= 1 && rating <= 5) map[rating] = count;
    }
    const title = ctx.isAr ? "توزيع التقييمات" : "Rating breakdown";
    return `
      <div class="xb-breakdown">
        <div class="xb-breakdown-heading">${XBReviewsUtils.escape(title)}</div>
        ${[5, 4, 3, 2, 1].map(star => {
          const count = map[star] || 0;
          const percentage = total > 0
            ? Math.min(100, Math.max(0, Math.round((count / total) * 100)))
            : 0;
          return `
            <div class="xb-break-row" aria-label="${star} stars: ${count}">
              <span class="xb-break-label">${star}<span class="xb-break-label-star" aria-hidden="true">★</span></span>
              <div class="xb-bar" aria-hidden="true"><div class="xb-bar-fill" style="width:${percentage}%"></div></div>
              <span class="xb-break-count">${count}</span>
              <span class="xb-break-percent">${percentage}%</span>
            </div>
          `;
        }).join("")}
      </div>
    `;
  },
  createToolbar(ctx) {
    const allowedSorts = ["newest", "oldest", "highest", "lowest"];
    const sortBy = allowedSorts.includes(ctx.sortBy) ? ctx.sortBy : "newest";
    return `
      <div class="xb-review-toolbar">
        <div class="xb-sort-bar">
          <label for="xb-review-sort">${XBReviewsUtils.escape(ctx.text.sortBy)}</label>
          <select id="xb-review-sort" class="xb-sort-select">
            <option value="newest" ${sortBy === "newest" ? "selected" : ""}>${XBReviewsUtils.escape(ctx.text.newest)}</option>
            <option value="oldest" ${sortBy === "oldest" ? "selected" : ""}>${XBReviewsUtils.escape(ctx.text.oldest)}</option>
            <option value="highest" ${sortBy === "highest" ? "selected" : ""}>${XBReviewsUtils.escape(ctx.text.highest)}</option>
            <option value="lowest" ${sortBy === "lowest" ? "selected" : ""}>${XBReviewsUtils.escape(ctx.text.lowest)}</option>
          </select>
        </div>
        <button type="button" class="xb-btn xb-open-modal xb-toolbar-write-review">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 5 4 4M4 20l4-1L20 7a2.8 2.8 0 0 0-4-4L4 15v5Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>
          ${XBReviewsUtils.escape(ctx.text.writeReview)}
        </button>
      </div>
    `;
  },
  createReviewList(ctx) {
    const reviews = Array.isArray(ctx.data?.reviews)
      ? ctx.data.reviews
      : [];
    if (!reviews.length) {
      return `
        <p class="xb-empty">
          ${XBReviewsUtils.escape(ctx.text.noReviews)}
        </p>
      `;
    }
    return `
      <div class="xb-review-slider" data-xb-reviews-version="horizontal-20261022" role="region" aria-label="${XBReviewsUtils.escape(ctx.text.title)}" aria-roledescription="${ctx.isAr ? 'عارض شرائح' : 'carousel'}">
      <div class="xb-review-list" id="xb-review-slider-track" dir="${ctx.isAr ? 'rtl' : 'ltr'}" data-review-count="${reviews.length}" tabindex="0" aria-label="${ctx.isAr ? 'تصفّح التقييمات يمينًا ويسارًا' : 'Browse reviews horizontally'}">
        ${reviews
          .map(review => this.createReviewCard(ctx, review))
          .join("")}
      </div>
      ${reviews.length > 1 ? `
        <div class="xb-review-slider-controls">
          <button type="button" class="xb-review-slider-arrow xb-review-slider-prev" aria-controls="xb-review-slider-track" aria-label="${ctx.isAr ? 'التقييم السابق' : 'Previous review'}" disabled>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <span class="xb-review-slider-count" dir="ltr" aria-live="polite" aria-atomic="true">1 / ${reviews.length}</span>
          <button type="button" class="xb-review-slider-arrow xb-review-slider-next" aria-controls="xb-review-slider-track" aria-label="${ctx.isAr ? 'التقييم التالي' : 'Next review'}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      ` : ''}
      </div>
    `;
  },
  createReviewCard(ctx, review = {}) {
    const customerName = String(
      review.customer_name ?? ""
    );
    const reviewTitle = String(
      review.review_title ?? ""
    ).trim();
    const reviewBody = String(
      review.review_body ?? ""
    );
    const reviewId = String(review.id ?? "");
    const rating = Math.min(
      5,
      Math.max(0, Number(review.rating) || 0)
    );
    const helpfulCount = Math.max(
      0,
      Math.floor(Number(review.helpful_count) || 0)
    );
    const formattedDate = XBReviewsUtils.formatDate(
      review.created_at,
      ctx.locale
    );
    return `
      <article class="xb-review-card">
  <div class="xb-review-user">
    <div class="xb-review-avatar">
      ${XBReviewsUtils.escape(
        XBReviewsUtils.initials(customerName)
      )}
    </div>
    <div class="xb-review-main">
      <div class="xb-review-name-row">
        <strong>
          ${XBReviewsUtils.escape(customerName)}
        </strong>
        ${this.createVerifiedBadge(ctx, review)}
      </div>
      <div class="xb-review-meta-row">
        <div class="xb-review-stars" role="img" aria-label="${rating} ${ctx.isAr ? 'من 5 نجوم' : 'out of 5 stars'}">
          <span aria-hidden="true">${XBReviewsUtils.stars(rating)}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="xb-review-content" tabindex="0" role="region" aria-label="${ctx.isAr ? 'نص التقييم' : 'Review text'}">
  ${
    reviewTitle
      ? `
        <h3 class="xb-review-title" dir="auto">
          ${XBReviewsUtils.escape(reviewTitle)}
        </h3>
      `
      : ""
  }
  <p class="xb-review-text" dir="auto">${XBReviewsUtils.escape(reviewBody.trim())}</p>
  </div>
  <div class="xb-review-footer">
    <button
  type="button"
  class="xb-helpful-btn ${
    review.user_has_voted ? "is-voted" : ""
  }"
  data-review-id="${XBReviewsUtils.escape(reviewId)}"
  aria-pressed="${
    review.user_has_voted ? "true" : "false"
  }"
>
      <svg
        class="xb-helpful-icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          d="M7 10v10H4V10h3Zm2 10V9.5l3.6-6.2c.2-.4.7-.6 1.1-.5l.5.1c.8.2 1.3.9 1.2 1.7L15 9h4.2c1.5 0 2.7 1.3 2.5 2.8l-.8 5.8c-.2 1.4-1.4 2.4-2.8 2.4H9Z"
          fill="currentColor"
        />
      </svg>
      ${XBReviewsUtils.escape(ctx.text.helpful)}
      (<span>${helpfulCount}</span>)
    </button>
    <time class="xb-review-date" datetime="${XBReviewsUtils.escape(String(review.created_at ?? ""))}">
      ${XBReviewsUtils.escape(formattedDate)}
    </time>
  </div>
</article>
    `;
  },
  createVerifiedBadge(ctx, review = {}) {
    const isVerified =
      Number(review.verified_purchase) === 1;
    if (!isVerified) {
      return "";
    }
    const label = ctx.isAr
      ? "عملية شراء موثقة"
      : "Verified Purchase";
    return `
      <span class="xb-verified-badge">
        <span aria-hidden="true" class="xb-verified-icon">
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M12 2.75l2.28 1.42 2.67-.12 1.32 2.32 2.37 1.24-.18 2.67L21.75 12l-1.29 1.72.18 2.67-2.37 1.24-1.32 2.32-2.67-.12L12 21.25l-2.28-1.42-2.67.12-1.32-2.32-2.37-1.24.18-2.67L2.25 12l1.29-1.72-.18-2.67 2.37-1.24 1.32-2.32 2.67.12L12 2.75z"
      fill="currentColor"
    />
    <path
      d="M8.3 12.15l2.3 2.3 5.1-5.1"
      fill="none"
      stroke="#fff"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</span>
        ${XBReviewsUtils.escape(label)}
      </span>
    `;
  },
  createModal(ctx) {
    const loggedIn = Boolean(
      ctx.customer?.loggedIn
    );
    const customerName = String(
      ctx.customer?.name ?? ""
    );
    const customerEmail = String(
      ctx.customer?.email ?? ""
    );
    return `
      <div class="xb-modal" hidden>
        <div
          class="xb-modal-backdrop xb-close-modal"
          aria-hidden="true"
        ></div>
        <div
          class="xb-modal-card"
          role="dialog"
          aria-modal="true"
          aria-labelledby="xb-review-modal-title"
        >
          <button
            type="button"
            class="xb-modal-x xb-close-modal"
            aria-label="${ctx.isAr ? "إغلاق" : "Close"}"
          >
            ×
          </button>
          <form class="xb-review-form">
            <h3 id="xb-review-modal-title">
              ${XBReviewsUtils.escape(ctx.text.writeReview)}
            </h3>
            <div class="xb-star-picker">
              ${[1, 2, 3, 4, 5]
                .map(num => `
                  <button
                    type="button"
                    data-rating="${num}"
                    class="active"
                    aria-label="${num} ${
                      ctx.isAr ? "نجوم" : "stars"
                    }"
                  >
                    ★
                  </button>
                `)
                .join("")}
            </div>
            <input
              name="review_title"
              aria-label="${XBReviewsUtils.escape(ctx.text.reviewTitle)}"
              type="text"
              placeholder="${XBReviewsUtils.escape(
                ctx.text.reviewTitle
              )}"
              maxlength="120"
            >
            ${
              loggedIn
                ? `
                  <input
                    name="customer_name"
              aria-label="${XBReviewsUtils.escape(ctx.text.name)}"
                    type="hidden"
                    value="${XBReviewsUtils.escape(customerName)}"
                  >
                  <input
                    name="customer_email"
              aria-label="${XBReviewsUtils.escape(ctx.text.email)}"
                    type="hidden"
                    value="${XBReviewsUtils.escape(customerEmail)}"
                  >
                `
                : `
                  <input
                    name="customer_name"
              aria-label="${XBReviewsUtils.escape(ctx.text.name)}"
                    type="text"
                    placeholder="${XBReviewsUtils.escape(
                      ctx.text.name
                    )}"
                    required
                    minlength="3"
                    maxlength="80"
                    autocomplete="name"
                  >
                  <input
                    name="customer_email"
              aria-label="${XBReviewsUtils.escape(ctx.text.email)}"
                    type="email"
                    placeholder="${XBReviewsUtils.escape(
                      ctx.text.email
                    )}"
                    maxlength="254"
                    autocomplete="email"
                  >
                `
            }
            <textarea
              name="review_body"
              aria-label="${XBReviewsUtils.escape(ctx.text.reviewBody)}"
              placeholder="${XBReviewsUtils.escape(
                ctx.text.reviewBody
              )}"
              required
              minlength="5"
              maxlength="2000"
            ></textarea>
            <div class="xb-form-actions">
              <button
                type="button"
                class="xb-btn-secondary xb-close-modal"
              >
                ${XBReviewsUtils.escape(ctx.text.cancel)}
              </button>
              <button
                type="submit"
                class="xb-btn"
              >
                ${XBReviewsUtils.escape(ctx.text.submit)}
              </button>
            </div>
            <p
              class="xb-form-message"
              aria-live="polite"
            ></p>
          </form>
        </div>
      </div>
    `;
  }
};
